import { VesselMovementData, VesselPositionsData } from '@/types';
import {
  Core,
  VESSEL_MOVEMENTS,
  VESSEL_POSITIONS,
  VESSEL_MANIFEST,
} from '../Core';

class Vessel extends Core {
  getVesselMovements = async () =>
    this.get<VesselMovementData>(VESSEL_MOVEMENTS());

  getVesselPositions = async () =>
    this.get<VesselPositionsData>(VESSEL_POSITIONS());

  postVesselManifest = async (documentFile: FormData) =>
    this.post(VESSEL_MANIFEST(), documentFile, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export const vessel = new Vessel();
